import { Component } from "react";
import PropTypes from "prop-types";
import ColorStep from "./ColorStep";

class ColorSteps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editDetails: false,
    };
  }

  /**
   * Trigger the parent handler to show the add-step form.
   * @param {Event} e DOM event
   */
  onAddStep(e) {
    e.preventDefault();
    this.props.onAddStep();
  }

  render() {
    const { steps, owner } = this.props;

    return (
      <div>
        <div className="color-steps row">
          <div className="col-12">
            <div>
              <button size="xs" onClick={(e) => this.onAddStep(e)}>
                Add New Color Step
              </button>
              <button size="xs" onClick={(e) => this.props.onSavePalette(e)}>
                Save Palette
              </button>
            </div>
          </div>
          {steps.map((step, index) => {
            return (
              <div className="col-4" key={index}>
                <ColorStep
                  owner={owner}
                  step={step}
                  onEditStep={(step) => this.props.onEditStep(step)}
                  onDeleteStep={(step) => this.props.onDeleteStep(step)}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

ColorSteps.propTypes = {
  steps: PropTypes.array,
  readOnly: PropTypes.bool,
  owner: PropTypes.bool,
  paletteDetails: PropTypes.shape({
    paletteName: PropTypes.string,
  }),
  onAddStep: PropTypes.func,
  onEditStep: PropTypes.func,
  onDeleteStep: PropTypes.func,
  onSavePalette: PropTypes.func,
};

ColorSteps.defaultProps = {
  steps: [],
  owner: false,
  readOnly: true,
  details: {},
  onSavePalette: () => {},
  onAddStep: () => {},
  onEditStep: () => {},
  onDeleteStep: () => {},
};

export default ColorSteps;
